import { render } from "./FacilityPalmTreesChart.vue?vue&type=template&id=6ea2d600&scoped=true"
import script from "./FacilityPalmTreesChart.vue?vue&type=script&lang=js"
export * from "./FacilityPalmTreesChart.vue?vue&type=script&lang=js"

import "./FacilityPalmTreesChart.vue?vue&type=style&index=0&id=6ea2d600&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ea2d600"

export default script